import React from "react"
import CurrentBusinessHour from "../Common/Place/CurrentBusinessHour"
import * as styles from "./Styles/Title.module.scss"
import {
  BusinessHourSummary,
  BusinessHourTypeCode,
} from "../Utils/business_hour_summary"

const Title = (props) => {
  const summary = BusinessHourSummary.detect(props.place)
  return (
    <div>
      <div className={styles.title}>{props.place.name}</div>
      <div className={styles.businessHours}>
        {summary.code == BusinessHourTypeCode.opened && (
          <React.Fragment>
            <span className={styles.opened}>営業中</span>
            <span>・</span>
          </React.Fragment>
        )}
        {(summary.code == BusinessHourTypeCode.closed ||
          summary.code == BusinessHourTypeCode.opening) && (
          <React.Fragment>
            <span>営業時間外</span>
            <span>・</span>
          </React.Fragment>
        )}
        <span>{summary.text}</span>
      </div>
    </div>
  )
}

export default Title
